import { render } from "./CreateCabin.vue?vue&type=template&id=05789d1c"
import script from "./CreateCabin.vue?vue&type=script&lang=js"
export * from "./CreateCabin.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__